import { store } from '../index';
import { Constant, TOKEN_KEY, CART_DATA, STORE_DETAILS } from "./constant";
// eslint-disable-next-line no-unused-vars
const { accept } = Constant.OrderStatus;


export const cravrrOrderDataSet = (data) => {
    let {
        // eslint-disable-next-line no-unused-vars
        user: { store_id, location_id },

    } = { user: store.getState().sessionReducer, store: store.getState().sessionReducer?.store_details };


    const {
        paymentResp,
        cartProps: { addedItems,total_tax, total ,resultDis, tip },
        reducer: {
            customer: { cust_first_name,cust_mobile},
            orderType:{order},
            storeInfo,
            selectedTender,
            storeInfoConfig
        },
    } = data;

    // Calculate round off amount based on config and selected tender
    const roundOffSetting = storeInfoConfig?.general_config?.round_off;
    const configApplyFor = (storeInfoConfig?.general_config?.apply_for || "").toLowerCase();
    const configPaymentTypes = storeInfoConfig?.general_config?.payment_types || storeInfoConfig?.general_config?.round_off_payments;

    const currentTnd = selectedTender;
    const currentTndType = (currentTnd?.tnd_type || "").toLowerCase();
    const currentTndCode = (currentTnd?.tnd_code || "").toLowerCase();

    let isRoundOffApplicable = false;

    if (roundOffSetting === true || roundOffSetting === "true") {
      if (configApplyFor.includes("cash only")) {
        isRoundOffApplicable = currentTndType.includes("cash") || currentTndCode === "cash";
      } else if (configApplyFor.includes("selected payments") || Array.isArray(configPaymentTypes)) {
        if (Array.isArray(configPaymentTypes)) {
          isRoundOffApplicable = configPaymentTypes.some(item => {
            if (typeof item === "string") {
              const itemLower = item.toLowerCase();
              return currentTndType === itemLower || currentTndCode === itemLower || currentTndType.includes(itemLower);
            }
            if (typeof item === "object" && item) {
              const itemType = (item.tnd_type || item.type || "").toLowerCase();
              const itemCode = (item.tnd_code || item.code || "").toLowerCase();
              return currentTndType === itemType || currentTndCode === itemCode || (itemType && currentTndType.includes(itemType));
            }
            return false;
          });
        } else {
          isRoundOffApplicable = currentTndType.includes("cash") || currentTndCode === "cash";
        }
      } else {
        isRoundOffApplicable = true;
      }
    }

    const roundOffType = (storeInfoConfig?.general_config?.type || storeInfoConfig?.general_config?.round_off_type || "nearest").toLowerCase();
    const rawTotal = total + total_tax + (tip || 0);
    let roundedTotal = rawTotal;
    if (isRoundOffApplicable) {
      if (roundOffType === "up") {
        roundedTotal = Math.ceil(rawTotal);
      } else if (roundOffType === "down") {
        roundedTotal = Math.floor(rawTotal);
      } else {
        roundedTotal = Math.round(rawTotal);
      }
    }
    const roundOffAmount = parseFloat((roundedTotal - rawTotal).toFixed(2));

    // let OrderTime = new Date().toISOString();
    // console.log(OrderTime);
  
    const originalDate = new Date();

    let hour =originalDate.getHours();
    let min= originalDate.getMinutes();
    let sec= originalDate.getSeconds();
    
        originalDate.setUTCHours(hour);
        originalDate.setUTCMinutes(min);
        originalDate.setUTCSeconds(sec);
        const isoDate = originalDate.toISOString();


        
        // const groupBy = function(xs, key) {
        //     return xs.reduce(function(rv, x) {
        //       (rv[x[key]] = rv[x[key]] || []).push(x);
        //       return rv;
        //     }, {});
        //   };
          
        //   const ItemGroupByStore= groupBy(addedItems,"store_id");
  
        

    //****************  Items info [START]*/
    let items = [];
    for (let i = 0; i < addedItems.length; i++) {
        let {
            _id,
            category_id,
            tag,
            description,
            item_img,
            item_display_img,
            quantity,
            item_variant,
            dietary,
            unit_of_measurement,
            total_net_sale,
            total_discount,
            total_gross_sale,
            total_item_tax,
            sub_total,
            taxAmount,			
            tax,
            modifiers_group,
        } = addedItems[i];
        const {
            plu,
            sku,
            variant_name,
            mappin_id,
            item_id,
            modifier_varaint,
        } = item_variant[0];

        let ItemName= addedItems[i].item_name
        let AlisaNAme =addedItems[i]?.item_variant[0]?.alias_name
     

        
        let selected_modifier = [];
        for(let k = 0; k < modifier_varaint?.length; k++) {
            const mod = modifier_varaint[k];
            const mgData = modifiers_group.find((e) => e?.mg_id === mod?.mg_id);
            const mvData = mgData?.item_modifier?.find((e) => e?.mv_id === mod?.mv_id);
          if(modifiers_group[0]?.item_modifier.length>1 ){
            if(mgData && mvData) {
                const { item_modifier, ...rest } = mgData;
                selected_modifier.push({...rest, modifiers: [mvData]});
            }
              }
        }
        
        items.push({
            _id: _id,
            store_id: store_id,
            item_id,
            sku: sku,
            category_id: category_id,
            description: description,
            dietary: dietary,
            unit_of_measurement,			
            item_img: item_img,
            item_name: ItemName,
            variant_name: variant_name,	
            tag: tag,		
            item_display_img:item_display_img,
            mappin_id: mappin_id,
            regular_sales_unit_price: plu,
            quantity: quantity,
            status: true,		
            price_override: [],
            promotions: [],	
            selectedAddonsItems: [],
            selected_modifier,
            extended_amount: plu,
            itemConfirmed: false,
            sub_total,			
            taxAmount,
            is_void: false,
            tax,
            alias_name: AlisaNAme,
            total_discount,
            total_gross_sale,
            total_item_tax,
            total_net_sale,			
        });
    }

   
   
    //****************  Items info [END]*/
    const _data = {
        item_details: items,
        store_details: {
            currencycode: storeInfo?.store_currency,
            device_id: "",
            emp_name: "",
            emp_no: storeInfo?.emp_no,
            emp_session_id : "65bf45523bfa380cb2b6d772",
            store_session_id : "65bf45410ed3546a615a54e9",
            pos_id: "",
            integration: storeInfo.integration,
            manager_override: [],
            order_begin_date_time: isoDate,
            order_end_date_time: isoDate,
            order_des: order?.order_type || "",
            order_code: order?.order_code || "",
            referencestr:storeInfo.referencestr || "",
            store_ad1: storeInfo.store_ad1 || "",
            store_ad2: storeInfo.store_ad2 || "",
            store_city: storeInfo.store_city || "",
            store_contact_no: storeInfo.store_contact_no || "",
            store_country: storeInfo.store_country || "",
            store_id: store_id,
            store_name: storeInfo.store_name || "",			
            store_state:storeInfo.store_name || "",	
            store_zip: storeInfo.store_zip || "",	
            tent_id: "",
            terminal_id: "",
        },
        customer_details: [
            {
                cust_mobile: cust_mobile ? cust_mobile: "999999999",
                cust_first_name: cust_first_name ? cust_first_name : "Guest",
            },
        ],



        cash_round_off: 0,
        change_tender: 0,
        comments: "",		
        is_void: false,
        order_state: "ACCEPT",
        order_status: "OPEN",
        order_source_code:"QR",
        is_kot_printed:false,
        order_source:"QR Order",
        order_type: order?.order_type || "",
        payment_details: [
            {
                ...selectedTender,
                amount: (total + total_tax + roundOffAmount),
                transResponse: paymentResp
            },
        ],
        round_off_amount: roundOffAmount,
        rounded_total: roundedTotal,
        sub_total: total,
        tip_amount: 0,
        tip_percentage: 0,
        total_discount: resultDis,
        total_gross_sale: (total + total_tax),
        total_item_tax: total_tax,
        total_net_sale: (total),
        transaction_grand_amount: (total + total_tax + roundOffAmount),
    };
    return _data;
};



export const getOrderTypeDropDown = () => {
    let OrderTypeDropDown = [{ text: "Self Pickup", value: "Self_Pickup" }];
    let store = localStorage.getItem(STORE_DETAILS);

    if (store) {
        const {
            store: {
                Setting: {
                    WebApp: { IsTableOrder },
                },
            },
        } = JSON.parse(store);
        console.log(
            "store===*****************",
            JSON.parse(store),
            "IsTableOrder=",
            IsTableOrder
        );
        if (IsTableOrder) {
            OrderTypeDropDown.push({ text: "In Store", value: "At_Table" });
        }
    }
    return OrderTypeDropDown;
};

export const getPaymentType = () => {
    let OrderTypeDropDown = [{ text: "Self Pickup", value: "Self_Pickup" }];
    let store = localStorage.getItem(STORE_DETAILS);

    if (store) {
        const {
            store: {
                Setting: {
                    WebApp: { IsTableOrder },
                },
            },
        } = JSON.parse(store);
        console.log(
            "store===*****************",
            JSON.parse(store),
            "IsTableOrder=",
            IsTableOrder
        );
        if (IsTableOrder) {
            OrderTypeDropDown.push({ text: "In Store", value: "At_Table" });
        }
    }
    return OrderTypeDropDown;
};
